import { render, staticRenderFns } from "./ActEvaluasi.vue?vue&type=template&id=afa65a9e&"
import script from "./ActEvaluasi.vue?vue&type=script&lang=js&"
export * from "./ActEvaluasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports